import { ref } from "vue";
import { PhieuNhapXuatStatusEnum } from "../enums/phieuNhapXuatStatus.enum";

const useFilterPhieuNhapXuat = ({
  loaiPhieu,
}: {
  loaiPhieu: 'nhap' | 'xuat';
}) => {
  void loaiPhieu;

  const isTemporaryFilter = ref<boolean | null>(null);
  const processStatusFilter = ref<PhieuNhapXuatStatusEnum | ''>('');
  const loaiPhieuFilter = ref<number | ''>('');

  return {
    loaiPhieuFilter,
    isTemporaryFilter,
    processStatusFilter,
  };
};

export { useFilterPhieuNhapXuat };
